import { Heading, HStack, Image, Tab, TabList, TabPanel, TabPanels, Tabs, VStack, Text, Stack, Box } from '@chakra-ui/react';
import LoopHeaderMockUp from 'Assets/Images/LoopHeaderMockUp.png';
import checkmark from 'Assets/svg/Checkmark.svg';
import React from 'react';
import { IChildren, IHowItWorksLocalizationDocument } from 'Types/Interface/Sanity';


interface IBenefitsProps{
	howItWorksLocalization: IHowItWorksLocalizationDocument | null
}

export const Benefits = ({howItWorksLocalization}: IBenefitsProps) => {
	return(
		<Stack direction={['column', null, null, 'column', 'row']} gap={['30px','100px']} >
			<Image objectFit={'cover'} w={['388px', 'auto', null, null, '620px']} h={['400px', 'auto', null, null, '610px']} borderRadius={['3px','5px']} src={LoopHeaderMockUp} />
			<VStack spacing={'30px'} align={'flex-start'} justify={'center'}>
				<Heading textTransform={'uppercase'} fontSize={['20px','30px']} fontWeight={'bold'}>A Win-Win for Brands and Customers</Heading>
				<Tabs variant='unstyled' >
					<TabList bg={'#ECEFF2'} w={['200px','236px']} h={'46px'} borderRadius={'20px'} alignItems={'center'} mb={['30px','40px']}  >
						<Tab _selected={{ color: 'black', bg: 'white', borderRadius: '20px' }} w={['74','96px']} h={['31px','36px']} fontSize={['12px','14px']} ml={'5px'}>Brands</Tab>
						<Tab _selected={{ color: 'black', bg: 'white', borderRadius: '20px' }} w={['100px','120px']} h={['31px','36px']} fontSize={['12px','14px']}>Customers</Tab>
					</TabList>
					<TabPanels >
						<TabPanel p={2}>
							{
								howItWorksLocalization?.brandsBenefits?.map((benefit) => {
									return(
										<HStack spacing={'4px'} w={['100%', null, null, null,'auto']} alignItems={'baseline'} key={benefit._key} mb={'30px'}>
											<Image pos={'relative'} top={'5px'} boxSize={'20px'} src={checkmark} />
											{/* <Text color={'blackText.200'} fontSize={['16px','18px']}>
												{benefit.children.map((child:IChildren) =>
													child.marks.includes('strong') ? (
													<strong key={child._key}>{child.text}</strong>
													) : (
													<span key={child._key}>{child.text}</span>
													)
												)}
											</Text> */}
											<Text color={'blackText.200'} fontSize={['16px', '18px']}>
												{benefit.children.map((child: IChildren) => {
													const isBold = child.marks.includes('strong');

													if (isBold) {
														return (
															<Heading
																key={child._key}
																as="strong"
																display={{ base: 'block', md: 'inline' }}
																fontSize={['16px', '18px']}
															>
																{child.text}
															</Heading>
														);
													}

													return (
														<Box
															key={child._key}
															as="span"
															display={{ base: 'block', md: 'inline' }}
														>
															{child.text}
														</Box>
													);
												})}
											</Text>
										</HStack>
									);
								})
							}
						</TabPanel>
						<TabPanel p={2}>
							{
								howItWorksLocalization?.customersBenefits?.map((benefit) => {
									return(
										<HStack spacing={'4px'} w={['100%','auto']} alignItems={'flex-start'} key={benefit._key} mb={'30px'}>
											<Image pos={'relative'} top={'5px'} boxSize={'20px'} src={checkmark} />
											<Text color={'blackText.200'} fontSize={['16px', '18px']}>
												{benefit.children.map((child: IChildren) => {
													const isBold = child.marks.includes('strong');

													if (isBold) {
														return (
															<Heading
																key={child._key}
																as="strong"
																display={{ base: 'block', md: 'inline' }}
																fontSize={['16px', '18px']}
															>
																{child.text}
															</Heading>
														);
													}

													return (
														<Box
															key={child._key}
															as="span"
															display={{ base: 'block', md: 'inline' }}
														>
															{child.text}
														</Box>
													);
												})}
											</Text>
										</HStack>
									);
								})
							}
						</TabPanel>
					</TabPanels>
				</Tabs>
			</VStack>
		</Stack>
	);
};